import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../../redux/storeConfig/store";
import { Plan, PlanWithVariant, Subscription } from "./plans.types";

export const selectTeamsReducer = (state: RootState) => state.teams;

export const selectPlans = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.plans as Plan[],
);

export const selectUpdateSubscriptionId = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.updateSubscriptionId,
);

export const setUpdateSubscriptionId = (updateSubscriptionId: number) => {
  return {
    type: "UPDATE_SUB_ID",
    id: updateSubscriptionId,
  };
};

export const selectPlansWithVariants = createSelector(
  [selectPlans],
  (plans) => {
    const plansWithVariants: PlanWithVariant[] = [];
    plans
      ?.sort((a, b) => a.id - b.id)
      ?.map((plan) => {
        const { variants, ...rest } = plan;
        variants
          ?.sort((a, b) => a.duration - b.duration)
          ?.map((variant) => {
            plansWithVariants.push({
              ...rest,
              variant,
              key: `${rest?.id},${variant?.id}`,
            });
            return null;
          });
        return null;
      });
    return plansWithVariants;
  },
);

export const selectSubscriptions = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.subscriptions as Subscription[],
);

export const selectSubscriptionFromId = createSelector(
  [selectSubscriptions, (_: any, id: number) => id],
  (subscriptions, id) => {
    return subscriptions?.find((s) => s.id === id);
  },
);

export const selectUpdateEventActionId = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.updateEventActionId,
);

export const selectViewEventActionId = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.viewEventActionId,
);

export const selectEventActions = createSelector(
  [selectTeamsReducer],
  (reducer) => reducer.eventActions,
);

export const selectEventActionFromId = createSelector(
  [selectEventActions, (_: any, id: number) => id],
  (eal: { id: number }[], id) => {
    return eal?.find((ea) => ea.id === id);
  },
);
